import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from '@/components/ui/ConfirmationDialog/ConfirmationDialog';

interface SessionTimeoutDialogProps {
  /** הזמן שנותר עד הניתוק האוטומטי. */
  msUntilLogout: number;
  onExtend: () => void;
  onLogout: () => void;
}

/**
 * האזהרה שלפני הניתוק על חוסר פעילות (HAT-1092). בלעדיה אנשים היו מאבדים
 * טופס פתוח באמצע, והניתוק היה נראה כתקלה במקום כהתנהגות מכוונת.
 */
const SessionTimeoutDialog = ({ msUntilLogout, onExtend, onLogout }: SessionTimeoutDialogProps) => {
  const { t } = useTranslation();
  const seconds = Math.max(0, Math.ceil(msUntilLogout / 1000));

  /*
   * ConfirmationDialog קורא ל-onCancel וגם ל-onOpenChange(false) באותה לחיצה,
   * ובלי השער הזה "להתנתק עכשיו" היה מנתק ומיד גם מאריך את הסשן.
   */
  const decidedRef = useRef(false);
  const decideOnce = (action: () => void) => {
    if (decidedRef.current) return;
    decidedRef.current = true;
    action();
  };

  return (
    <ConfirmationDialog
      open
      onOpenChange={(open) => {
        // סגירה ב-X או ב-Escape נחשבת נוכחות - ממשיכים לעבוד.
        if (!open) decideOnce(onExtend);
      }}
      title={t('sessionTimeout.title')}
      message={t('sessionTimeout.message', { seconds })}
      confirmText="sessionTimeout.stayConnected"
      cancelText="sessionTimeout.logoutNow"
      onConfirm={() => decideOnce(onExtend)}
      onCancel={() => decideOnce(onLogout)}
      variant="danger"
    />
  );
};

export default SessionTimeoutDialog;
